// extracted by mini-css-extract-plugin
export var navbarSubLink = "L_f9 d_f9 d_f3 d_Z d_cb d_dl d_br d_bS";
export var menuLink = "L_v6 d_fZ d_dz";
export var subPageLink = "L_gd d_gd";
export var burger = "L_ws";
export var sublinkSize = "L_wt";
export var linkSize = "L_wv";
export var Link = "L_rs q_rs q_qK q_q3";